export { default as GDMSlider } from './GDMSlider';

export type { GDMSliderComponent, GDMSliderProps } from './GDMSlider.type';
